<template>
    <div>
        <div v-if="isCodeOk">
            {{ $t('code sent successfully') | capitalize }}!
        </div>
        <div v-else>
            <Intro :phone="user.phone"/>
            <GenericForm
                :fields="fields"
                :asyncErrors="asyncErrors"
                @submit="onValidate"
            >
                <template slot-scope="slotProps">
                    <CustomInput
                        name="code"
                        :label="$t('the SMS code')"
                        v-model="fields.code.value"
                        :errorMessage="slotProps.errors.code"
                        @valueChanged="slotProps.onValueChanged"
                    />
                    <SendSms
                        :isSmsSent="isSmsSent"
                        :smsSendError="smsSendError"
                        @sendSms="onSendSms"
                        @changePhone="onChangePhone"
                        @helpClick="showHelp"
                    />
                    <div
                        v-if="error"
                        class="message message--error-big"
                    >
                        {{ $t('Something went wrong. Please try again') | capitalize }}
                    </div>
                    <div class="button-group">
                        <button
                            @click="closeAllModals"
                            class="btn btn__secondary"
                        >
                            {{ $t('not now') | capitalize }}
                        </button>
                        <CustomButton
                            :isLoading="isLoading"
                            type="submit"
                            class="btn btn__primary"
                        >
                            <template v-if="error">
                                {{ $t('retry') | capitalize }}
                            </template>
                            <template v-else>
                                {{ $t('send') | capitalize }}
                            </template>
                        </CustomButton>
                    </div>
                </template>
            </GenericForm>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { isRequired } from '@modules/shared/validators/forms';
    import ValidationError from '@core/errors/network/ValidationError';
    import UserService from '@core/services/user/UserService';
    import { routeNames } from '@app/router';
    import { errorGuard } from '@app/utils';
    import SendSms from './components/SendSms';
    import Intro from './components/Intro';

    export default {
        name: 'SmsValidationContainer',
        data() {
            return {
                fields: {
                    code: {
                        value: null,
                        validate: [
                            isRequired,
                        ]
                    },
                },
                asyncErrors: {},
                isLoading: false,
                isSmsSent: false,
                isCodeOk: false,
                smsSendError: '',
                error: '',
            };
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
            name() {
                return this.data;
            }
        },
        methods: {
            ...mapActions('ui/help', [
                'showHelp',
            ]),
            ...mapActions('data/authentication', [
                'setUserData',
            ]),
            ...mapActions('ui/modal', [
                'closeAllModals',
            ]),
            onSendSms() {
                this.serverCall(async () => {
                    await UserService.getInstance().sendSmsCode();
                    this.isSmsSent = true;
                });
            },
            onValidate() {
                this.serverCall(async () => {
                    await UserService.getInstance().validateSmsCode(this.fields.code.value);
                    this.setUserData({
                        key: 'shouldVerifySms',
                        value: false
                    });
                    this.isCodeOk = true;
                });
            },
            async serverCall(action) {
                this.error = '';
                this.isLoading = true;
                await errorGuard({
                    action: () => action(),
                    onError: (e) => {
                        if (e instanceof ValidationError) {
                            this.asyncErrors = e.fieldErrors;
                        } else {
                            this.error = 'Something went wrong. Please try again';
                        }
                    },
                    showGlobalError: false,
                });
                this.isLoading = false;
            },
            onChangePhone() {
                this.$router.push({ name: routeNames.settings });
                this.closeAllModals();
            }
        },
        components: {
            SendSms,
            Intro
        }
    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/app/modules/userProfile/smsValidation/SmsValidationContainer.vue